export default __webpack_public_path__ + "static/media/banner-03.bcebb4cc.jpg";